import bigcommerceGenericDefaults from '../bigcommerce-generic/config.js';

function InitFunc() {
  bigcommerceGenericDefaults.InitFunc?.();

  if (window.document.querySelector('#cm_results, #cm-brand-list')) {
    window.document.body.classList.remove('page--cavio');
  }
}

export default {
  includes: ['bigcommerce-generic'],
  ...bigcommerceGenericDefaults,
  InitFunc,
  Widgets: [
    ...bigcommerceGenericDefaults.Widgets.filter(
      (w) =>
        ![
          'Garage',
          'SearchBox',
          'SearchBoxDialogButton',
          'CategoryPage',
          'FacetCategoryTiles',
          'VerifyFitment',
          'FitmentTable',
        ].includes(w.name),
    ),
    {
      name: 'SearchBox',
      type: 'SearchBoxDialogButton',
      location: {
        selector: '.navUser-item.navUser-item--search',
        class: 'navUser-item navUser-item--search cm_mobile-hide',
        wrapper: 'li',
      },
      template: 'searchBox/dialogButtonAdaptable',
    },
    {
      name: 'SearchBoxDialogButton',
      location: {
        insertBefore: '.navUser-item.navUser-item--search',
        class: 'navUser-item navUser-item--search cm_search-box-root__mobile cm_desktop-hide',
        wrapper: 'li',
      },
      template: 'searchBox/dialogButtonMobile',
    },
    {
      name: 'CategoryPage',
      type: 'SearchPage',
      location: 'body.listing-page-body .page.product--listing',
      template: 'SearchPage',
      visibleIf: () => window.location.pathname !== '/categories/',
    },
    {
      name: 'FacetCategoryTiles',
      type: 'FacetTiles',
      location: 'body.listing-page-body .page.product--listing',
      template: 'facetTiles/hierarchicalContainer',
      visibleIf: () => window.location.pathname.includes('/categories/'),
      isVehicleWidgetDisabled: !!window.document.querySelector('#cm-ymm'),
    },
    {
      name: 'VerifyFitment',
      location: { lastChildOf: 'body.product-page-body .productView-details' },
      template: 'fitmentSearch/verifyFitment',
    },
    {
      name: 'FitmentTable',
      location: { lastChildOf: 'body.product-page-body .accordion-contents' },
      template: 'fitmentSearch/fitmentTable',
    },
    {
      name: 'Garage',
      location: {
        insertBefore: '.navUser-item.navUser-item--cart',
        wrapper: 'li',
        class: 'navUser-item navUser-item--cart',
      },
      template: 'fitmentSearch/garage',
    },
  ],
};
